import { jsx } from "react/jsx-runtime";
import React__default from "react";
import { IMaskInput } from "react-imask";
import { TextField } from "../TextField/index.js";
import "@mui/material/TextField";
import "@mui/material/IconButton";
import "@mui/material/InputAdornment";
import "@mui/icons-material/Visibility";
import "@mui/icons-material/VisibilityOff";
import "@mui/icons-material/ErrorOutline";
const CustomTextMask = React__default.forwardRef(function CustomTextMask2({
  onChange,
  onAccept,
  ...props
}, ref) {
  return /* @__PURE__ */ jsx(IMaskInput, { ...props, inputRef: ref, onAccept: (value, maskRef, event) => {
    onChange == null ? void 0 : onChange({
      target: {
        name: props.name,
        value
      }
    });
    onAccept == null ? void 0 : onAccept(value, maskRef, event);
  } });
});
function MaskedInput({
  maskProps,
  onValueChange,
  mask,
  definitions,
  unmask,
  ...props
}) {
  return /* @__PURE__ */ jsx(TextField, { ...props, InputProps: {
    ...props.InputProps,
    inputComponent: CustomTextMask,
    inputProps: {
      ...maskProps,
      mask,
      definitions,
      unmask,
      onAccept: onValueChange
    }
  } });
}
export {
  MaskedInput
};
//# sourceMappingURL=index.js.map
